import { render, staticRenderFns } from "./EditionDeactivation.vue?vue&type=template&id=526d6e2f"
import script from "./EditionDeactivation.vue?vue&type=script&lang=js"
export * from "./EditionDeactivation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports